import { createTranslations } from '@npco/utils-translations'

export const setupFlowContactsStageTranslations = createTranslations({
  badge: 'Contacts',
  title: 'Manage customers and suppliers at a glance.',
  description:
    'Understand customer and supplier relationships better, with transaction tracking and extensive contact information.',
  point1: 'Build and manage customer and supplier profiles',
  point2: 'See payment and transaction history by contact and Zeller product',
  point3: 'Add contact categories and custom notes',
  point4: 'Included free with your Zeller Account',
  animationDataFilenameSmall: 'setup-flow-contacts-small',
  animationDataFilenameMedium: 'setup-flow-contacts-medium',
  animationDataFilenameLarge: 'setup-flow-contacts-large',
})
